import React from "react"
import { Text, TextBold, Spacer } from "./common"

interface DeliveryTextProps {
  deliveryDate: string
  orderWithin: String
}

const DeliveryText: React.FC<DeliveryTextProps> = ({
  deliveryDate,
  orderWithin,
}) => (
  <>
    <Text>Get it by</Text>
    <Spacer />
    <TextBold>{deliveryDate}</TextBold>
    <Spacer />
    <Text>order within</Text>
    <Spacer />
    <TextBold>{orderWithin}</TextBold>
  </>
)

export default DeliveryText
